import React from "react";
import Index from "./containers/Index";

function App() {
  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
